'use client'

import ReactDOM from 'react-dom'

/** Warms the connection to third-party origins we know we'll load a script from. */
export function PreconnectHints() {
  ReactDOM.preconnect('https://static.cloudflareinsights.com')
  return null
}
